// タブ機能の初期化
const tabs = () => {
  const tabGroups = document.querySelectorAll('.js-tabs');

  // クエリパラメータを取得
  const urlParams = new URLSearchParams(window.location.search);

  tabGroups.forEach((tabsContainer) => {
    const tabList = tabsContainer.querySelector('.js-tabs_tablist');

    // タブグループのIDを取得
    const tabGroupId = tabsContainer.getAttribute('id');
    if (!tabGroupId) {
      return;
    }

    // このタブグループのクエリパラメータを取得
    const activeTabId = urlParams.get(tabGroupId);

    // tablist ロールを自動付与
    if (tabList && !tabList.hasAttribute('role')) {
      tabList.setAttribute('role', 'tablist');
    }

    const tabs = tabsContainer.querySelectorAll('.js-tabs_tab');
    const panels = tabsContainer.querySelectorAll('.js-tabs_panel');

    // 初期タブを特定（優先順位に従って）
    let activeTabIndex = -1;

    // 1. クエリパラメータで指定されたタブ
    if (activeTabId) {
      // パネルIDがパラメータと一致する場合
      const paramPanelIndex = Array.from(panels).findIndex(
        (panel) => panel.id === activeTabId,
      );

      if (paramPanelIndex !== -1) {
        activeTabIndex = paramPanelIndex;
      } else {
        // aria-controlsがパラメータと一致するタブを探す
        const paramTabIndex = Array.from(tabs).findIndex(
          (tab) => tab.getAttribute('aria-controls') === activeTabId,
        );

        if (paramTabIndex !== -1) {
          activeTabIndex = paramTabIndex;
        }
      }
    }

    // 2. aria-selectedがtrueに設定されているタブ
    if (activeTabIndex === -1) {
      activeTabIndex = Array.from(tabs).findIndex(
        (tab) => tab.getAttribute('aria-selected') === 'true',
      );
    }

    // 3. 上記がなければ、最初のタブ
    if (activeTabIndex === -1) {
      activeTabIndex = 0;
    }

    tabs.forEach((tab, tabIndex) => {
      // タブとパネルに一意のIDを設定
      const panelId =
        tab.getAttribute('aria-controls') || `${tabGroupId}-panel-${tabIndex}`;
      const tabId = tab.getAttribute('id') || `${tabGroupId}-tab-${tabIndex}`;

      // 必要な属性を設定（未設定の場合のみ）
      if (!tab.hasAttribute('role')) tab.setAttribute('role', 'tab');
      if (!tab.hasAttribute('id')) tab.setAttribute('id', tabId);
      if (!tab.hasAttribute('aria-controls'))
        tab.setAttribute('aria-controls', panelId);
      tab.setAttribute('tabindex', tabIndex === activeTabIndex ? '0' : '-1');
      tab.setAttribute(
        'aria-selected',
        tabIndex === activeTabIndex ? 'true' : 'false',
      );

      const panel = panels[tabIndex];
      if (panel) {
        // 必要な属性を設定（未設定の場合のみ）
        if (!panel.hasAttribute('role')) panel.setAttribute('role', 'tabpanel');
        if (!panel.hasAttribute('id')) panel.setAttribute('id', panelId);
        if (!panel.hasAttribute('aria-labelledby'))
          panel.setAttribute('aria-labelledby', tabId);
        if (tabIndex !== activeTabIndex) panel.setAttribute('hidden', '');
      }

      // クリックイベントでタブを切り替え
      tab.addEventListener('click', function () {
        // --scrollクラスがある場合のみスクロール
        const shouldScroll =
          tabsContainer.classList.contains('js-tabs--scroll');
        activateTab(tabsContainer, tab, true, false, shouldScroll);
      });

      // キーボード操作を追加
      tab.addEventListener('keydown', function (event) {
        // --scrollクラスがある場合のみスクロール
        const shouldScroll =
          tabsContainer.classList.contains('js-tabs--scroll');

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          const nextTab = tabs[tabIndex + 1] || tabs[0];
          nextTab.focus();
          activateTab(tabsContainer, nextTab, true, false, shouldScroll);
          event.preventDefault();
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          const prevTab = tabs[tabIndex - 1] || tabs[tabs.length - 1];
          prevTab.focus();
          activateTab(tabsContainer, prevTab, true, false, shouldScroll);
          event.preventDefault();
        } else if (event.key === 'Home') {
          tabs[0].focus();
          activateTab(tabsContainer, tabs[0], true, false, shouldScroll);
          event.preventDefault();
        } else if (event.key === 'End') {
          tabs[tabs.length - 1].focus();
          activateTab(
            tabsContainer,
            tabs[tabs.length - 1],
            true,
            false,
            shouldScroll,
          );
          event.preventDefault();
        } else if (event.key === 'Enter' || event.key === ' ') {
          activateTab(tabsContainer, tab, true, false, shouldScroll);
          event.preventDefault();
        }
      });
    });

    // 初期タブをアクティブ化
    if (activeTabIndex >= 0 && activeTabIndex < tabs.length) {
      // URLパラメータがあり、かつ--scrollクラスがある場合のみスクロールする
      const shouldScroll =
        !!activeTabId && tabsContainer.classList.contains('js-tabs--scroll');
      activateTab(
        tabsContainer,
        tabs[activeTabIndex],
        false,
        false,
        shouldScroll,
      ); // URLを更新しない
    }
  });

  function activateTab(
    tabsContainer,
    tab,
    setFocus = true,
    updateUrl = true,
    shouldScroll = false,
  ) {
    const tabGroupId = tabsContainer.getAttribute('id');
    const tabs = tabsContainer.querySelectorAll('.js-tabs_tab');
    const panels = tabsContainer.querySelectorAll('.js-tabs_panel');

    tabs.forEach((t, i) => {
      const isActive = t === tab;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');

      const panel = panels[i];
      if (panel) {
        if (isActive) {
          panel.removeAttribute('hidden');

          // URLクエリパラメータを更新（オプション）
          if (updateUrl && tabGroupId) {
            // パネルIDをクエリパラメータの値として使用
            updateUrlParam(tabGroupId, panel.id);
          }

          // タブコンテナまでスクロール（shouldScrollがtrueの場合のみ）
          if (shouldScroll) {
            setTimeout(() => {
              const targetElement =
                tabsContainer.querySelector('.js-tabs_tablist') ||
                tabsContainer;
              if (targetElement) {
                // ヘッダーの高さを取得（set-header-height-variable.jsで設定された値を使用）
                let headerHeight = 0;
                const headerHeightProp = window
                  .getComputedStyle(document.documentElement)
                  .getPropertyValue('--js-height__header');

                if (headerHeightProp) {
                  const match = headerHeightProp.match(/([0-9.]+)/);
                  if (match) {
                    headerHeight = parseFloat(match[1]);
                  }
                }

                // WordPress管理バーの高さも考慮
                const adminBarHeightProp = window
                  .getComputedStyle(document.documentElement)
                  .getPropertyValue('--wp-admin--admin-bar--height');

                if (adminBarHeightProp) {
                  const match = adminBarHeightProp.match(/([0-9.]+)/);
                  if (match) {
                    headerHeight += parseFloat(match[1]);
                  }
                }

                // スクロール位置を計算（少し余白を追加）
                const offset =
                  targetElement.getBoundingClientRect().top +
                  window.pageYOffset -
                  headerHeight -
                  20;

                window.scrollTo({
                  top: offset,
                  behavior: 'smooth',
                });
              }
            }, 100);
          }
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    });

    if (setFocus) {
      tab.focus(); // フォーカスを移動（オプション）
    }
  }

  // URLクエリパラメータを更新する関数
  function updateUrlParam(key, value) {
    const url = new URL(window.location);
    url.searchParams.set(key, value);
    window.history.pushState({}, '', url);
  }

  // popstate イベントでブラウザの戻る/進むボタンに対応
  window.addEventListener('popstate', function () {
    const urlParams = new URLSearchParams(window.location.search);

    tabGroups.forEach((tabsContainer) => {
      const tabGroupId = tabsContainer.getAttribute('id');
      if (!tabGroupId) return;

      const activePanelId = urlParams.get(tabGroupId);
      if (!activePanelId) return;

      const panels = tabsContainer.querySelectorAll('.js-tabs_panel');
      const tabs = tabsContainer.querySelectorAll('.js-tabs_tab');

      // パネルIDに一致するタブを探す
      const panelIndex = Array.from(panels).findIndex(
        (panel) => panel.id === activePanelId,
      );
      if (panelIndex !== -1 && tabs[panelIndex]) {
        // --scrollクラスがある場合のみスクロール
        const shouldScroll =
          tabsContainer.classList.contains('js-tabs--scroll');
        activateTab(
          tabsContainer,
          tabs[panelIndex],
          false,
          false,
          shouldScroll,
        );
      }
    });
  });
};

export { tabs };
